import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import PropTypes from 'prop-types'
import { BrandLink } from '../BrandLink'

const BrandCard = ({ className, url, name, logo, slug, affiliate, external = false }) => {
  const BrandCardLink = props => external
    ? <BrandLink url={url} title={name} affiliate={affiliate} {...props} />
    : <Link to={`/marques/${slug}/`} {...props} />

  return (
    <BrandCardLink>
      <GatsbyImage
        image={logo.gatsbyImageData}
        alt={logo.alt || name}
        title={name}
        className={className || "h-56 w-full object-cover object-center"}
      />
    </BrandCardLink>
  )
}

BrandCard.propTypes = {
  title: PropTypes.string,
  image: PropTypes.object,
  slug: PropTypes.string,
}

export default BrandCard
